import { Stack, Typography, TypographyProps } from '@mui/material';
import { grey } from '@mui/material/colors';
import { formatCurrency } from 'util/currency';

type AmountProps = {
  amount: number;
  currencyCode?: string;
  precision?: number;
  numberProps?: TypographyProps;
  codeProps?: TypographyProps;
  variant?: TypographyProps['variant'];
};

const Amount = ({
  amount,
  currencyCode = 'USD',
  precision,
  numberProps = {},
  codeProps = {},
  variant,
}: AmountProps) => {
  return (
    <Stack direction="row" spacing={0.5}>
      <Typography
        fontWeight="bold"
        data-testid="Amount"
        m={0}
        variant={variant}
        {...numberProps}
      >
        {formatCurrency(amount, currencyCode, precision)}
      </Typography>
      <Typography
        color={grey[500]}
        fontWeight="normal"
        variant={variant}
        {...codeProps}
      >{`${currencyCode?.toUpperCase()}`}</Typography>
    </Stack>
  );
};
export default Amount;
